"use strict";

var _templateObject, _templateObject2;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Validator = void 0;
var _tsRes = require("ts-res"),
  _kameleoonError = require("../kameleoonError"),
  _constants = require("./constants"),
  _logging = require("../logging");
var Validator = /*#__PURE__*/function () {
  function Validator() {
    _classCallCheck(this, Validator);
  }
  return _createClass(Validator, null, [{
    key: "validateVersion",
    value: function validateVersion(a) {
      var b = a.split(".").map(function (a) {
        return parseInt(a, 10);
      });
      for (; 3 > b.length;) b.push(0);
      return b.some(function (a) {
        return isNaN(a);
      }) ? (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.SemanticVersionParse, a)) : (0, _tsRes.Ok)(b.slice(0, 3));
    }
  }, {
    key: "validateDomain",
    value: function validateDomain(a) {
      if (!a) return (0, _tsRes.Err)();
      a = a.toLowerCase();
      var b = [_constants.HTTP, _constants.HTTPS];
      for (var _i = 0, _b = b; _i < _b.length; _i++) {
        var c = _b[_i];
        if (a.startsWith(c)) {
          a = a.substring(c.length), _logging.KameleoonLogger.warning(_templateObject || (_templateObject = _taggedTemplateLiteral(["The top-level domain contains ", ". Domain after protocol trimming: ", ""])), c, a);
          break;
        }
      }
      return _constants.REGEX_DOMAIN.test(a) || a === _constants.LOCALHOST ? (0, _tsRes.Ok)(a) : (_logging.KameleoonLogger.error(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["The top-level domain ", " is invalid. The value has been set as provided, but it does not meet the required format for proper SDK functionality. Please check the domain for correctness."])), a), (0, _tsRes.Ok)(a));
    }
  }]);
}();
exports.Validator = Validator;